import { render } from "./mandatory-field-edition.vue?vue&type=template&id=6e34a36a&ts=true"
import script from "./mandatory-field-edition.vue?vue&type=script&lang=ts"
export * from "./mandatory-field-edition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__